import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import StaticPageManagement from '../../../components/SiteAdmin/StaticPageManagement';
import messages from '../../../locale/messages';
export class StaticPage extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.staticpageManagement)}</h1>
        <StaticPageManagement />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(StaticPage)
